// A QR code is just an image, so nothing extra ships to the phone: the code is
// drawn on demand from the page's own address. Nothing is stored, and a page
// with a hundred cards costs nothing until one of them is opened.

/** The scannable image for any URL, at the pixel size the layout needs. */
export function qrImageUrl(url, size = 240) {
  if (!url) return "";
  return `https://quickchart.io/qr?text=${encodeURIComponent(url)}&size=${size}&margin=1&ecLevel=M`;
}